import React, { Fragment } from 'react';

import { DateTime } from 'luxon';

import { type IStudentGradeModel } from '@common/models/StudentGrades/StudentGrade';

import GradeGridComment from './Comment';
import GridGradeScore from './Grade';
import * as Styled from './styled';

interface PropsType {
	grades: IStudentGradeModel[];
	date: string;
	index: number;
}

function GradeGridListItem({ grades, date, index }: PropsType) {
	const formattedDate = DateTime.fromISO(date).toFormat('ccc. dd.LL.yyyy');

	const programName = grades?.[0]?.program?.name;

	return (
		<Styled.Wrap elevation={2} index={index}>
			<Styled.GradesWrap>
				{grades.map((grade, index) => (
					<Fragment key={index}>
						<GridGradeScore grade={grade} />
						<GradeGridComment comment={grade.final_comment} />
					</Fragment>
				))}
			</Styled.GradesWrap>
			<Styled.InfoWrap>
				{programName && <Styled.ProgramName>{programName}</Styled.ProgramName>}
				<Styled.DateWrap>
					<Styled.Date>{formattedDate}</Styled.Date>
				</Styled.DateWrap>
			</Styled.InfoWrap>
		</Styled.Wrap>
	);
}

export default GradeGridListItem;
